import React from 'react';
import EnhancedDashboard from '../components/EnhancedDashboard';

const Dashboard = () => {
  // Auth check is now handled by ProtectedRoute wrapper in App.js
  return <EnhancedDashboard />;
};

export default Dashboard;